class PredictiveSearchComponent extends HTMLElement {

  constructor() {
    super();

    this.#updateSubmitButtonReference();

    this.searchInput = this.querySelector('.search-input');
    this.resetButton = this.querySelector('.predictive-search__reset-button');

    this.searchInput.addEventListener('input', () => {
      this.#updateSubmitButtonVisibility();
    });

    this.searchPlaceholder = (this.getAttribute('data-search-placeholder') || '')
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean);

    this.resetButton?.addEventListener('click', () => {
      this.resetInput();
    });

    this.initTypingAnimation();
  }

  #updateSubmitButtonReference() {
    this.submitBtnWrapper = this.querySelector('.predictive-search-form__submit-button-wrapper');
  }

  #updateSubmitButtonVisibility() {
    if (this.searchInput.value.length > 0) {
      this.submitBtnWrapper?.classList.add('show');
      this.resetButton.classList.add('active');
    } else {
      this.submitBtnWrapper?.classList.remove('show');
      this.resetButton.classList.remove('active');
    }
  }

  initTypingAnimation() {
    const texts = this.searchPlaceholder;

    // Return early if no texts to animate
    if (!texts || texts.length === 0) return;

    let count = 0;
    let index = 0;
    let currentText = '';
    let isDeleting = false;
    let isUserTyping = false;
    let isTypingAnimationRunning = false;
    let animationTimeoutId = null;
    const speed = 100;

    const input = this.searchInput;
    if (!input) return;

    if (animationTimeoutId) {
      clearTimeout(animationTimeoutId);
    }

    const handleUserInput = () => {
      if (input.value.length > 0) {
        isUserTyping = true;
        if (animationTimeoutId) {
          clearTimeout(animationTimeoutId);
          animationTimeoutId = null;
        }
        isTypingAnimationRunning = false;
      } else {
        isUserTyping = false;
        isTypingAnimationRunning = false;
        setTimeout(() => {
          if (!isUserTyping && input.value.length === 0) {
            typingAnimation();
          }
        }, 50);
      }
    };

    input.addEventListener('input', handleUserInput);
    input.addEventListener('focus', () => {
      if (input.value.length > 0) {
        isUserTyping = true;
        if (animationTimeoutId) {
          clearTimeout(animationTimeoutId);
          animationTimeoutId = null;
        }
        isTypingAnimationRunning = false;
      }
    });
    input.addEventListener('blur', () => {
      if (input.value.length === 0) {
        isUserTyping = false;
        isTypingAnimationRunning = false;
        setTimeout(() => {
          if (!isUserTyping && input.value.length === 0) {
            typingAnimation();
          }
        }, 100);
      }
    });

    function typingAnimation() {
      if (animationTimeoutId) {
        clearTimeout(animationTimeoutId);
        animationTimeoutId = null;
      }

      if (isUserTyping) {
        isTypingAnimationRunning = false;
        return;
      }

      isTypingAnimationRunning = true;
      currentText = texts[count];

      if (isDeleting) {
        input.placeholder = currentText.slice(0, --index);
      } else {
        input.placeholder = currentText.slice(0, ++index);
      }

      if (!isDeleting && index === currentText.length) {
        isDeleting = true;
        animationTimeoutId = setTimeout(typingAnimation, 1000);
        return;
      } else if (isDeleting && index === 0) {
        isDeleting = false;
        count = (count + 1) % texts.length;
      }

      animationTimeoutId = setTimeout(typingAnimation, isDeleting ? speed / 2 : speed);
    }
    typingAnimation();
  }

  resetInput(){
    this.searchInput.value = '';
    this.resetButton.classList.remove('active');
    this.initTypingAnimation();
    this.#updateSubmitButtonReference();
    this.#updateSubmitButtonVisibility();
  }
}

customElements.define('predictive-search-component', PredictiveSearchComponent);
